import { Card, Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { GalleryTitle, MasonryGallery, MasonryGalleryCap } from "../../../Constant";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { MesoanryGalleryBody } from "./MesoanryGalleryBody";

const MasonryGalleryContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={MasonryGallery} parent={GalleryTitle} title={MasonryGallery} />
      <Container fluid>
        <Row>
          <Col sm="12" className="box-col-12">
            <Card className="pb-5">
              <CommonCardHeader title={MasonryGalleryCap} />
              <MesoanryGalleryBody />
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default MasonryGalleryContainer;
